<template>
	<scoped-overflow-layout :loading="!isReady">
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<bar-nav-back @navBack="navBack" />
				<menu-edit v-if="isAuthor"
					:message="$t('FEEDBACK_DELETE_CONFIRM_TITLE')"
					:details="$t('FEEDBACK_DELETE_CONFIRM_DETAILS')"
					@edit="edit"
					@remove="remove" />
				
				<v-spacer />

				<bar-pagination :page="index" :total="total" @previous="prevItem" @next="nextItem" />
			</v-toolbar>
		</template>

		<v-container fluid>
			<v-layout>
				<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
					<v-card>
						<v-layout class="pa-3 text--secondary" justify-space-between align-baseline>
							<v-flex shrink>{{ $t('FEEDBACK_DATE_LOCATION', { date: toSimpleDate(item.date), city: item.city }) }}</v-flex>
							<v-flex shrink>
								<v-chip label disabled outline color="primary">{{ item.area }}</v-chip>
							</v-flex>
						</v-layout>

						<v-card-text class="py-0">
							<v-layout wrap align-center>
								<v-subheader class="subheading pl-0">{{ $t('FEEDBACK_HEADER_RATING') }}</v-subheader>
								<v-rating dense readonly :value="item.rating" color="yellow darken-1" background-color="grey lighten-1" />
							</v-layout>
						</v-card-text>
						
						<v-subheader class="subheading">{{ $t('FEEDBACK_HEADER_CONTEXT') }}</v-subheader>
						<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.context)" />

						<v-subheader class="subheading">{{ $t('FEEDBACK_HEADER_PREPARATION') }}</v-subheader>
						<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.preparation)" />

						<v-subheader class="subheading">{{ $t('FEEDBACK_HEADER_EXECUTION') }}</v-subheader>
						<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.execution)" />

						<v-subheader class="subheading">{{ $t('FEEDBACK_HEADER_CONVICTIONS') }}</v-subheader>
						<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.convictions)" />

						<v-subheader class="subheading">{{ $t('FEEDBACK_HEADER_RECOMMENDATIONS') }}</v-subheader>
						<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.recommendations)" />
					</v-card>
				</v-flex>
			</v-layout>
				<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
					<footer-info :item="item" />
				</v-flex>
		</v-container>
	</scoped-overflow-layout>
</template>


<script>
import { mapGetters } from 'vuex';
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import BarNavBack from "@/components/BarNavBack.vue";
import BarPagination from "@/components/BarPagination.vue";
import FooterInfo from "@/components/FooterInfo.vue";
import MenuEdit from '@/dialogs/MenuEdit';
import { toRelativeDate, toAbsoluteDate, toSimpleDate } from '@/utils/formatters';
import { compile } from '@/utils/markdown';

export default {
	name: "action-feedback",
	components: { ScopedOverflowLayout, BarNavBack, BarPagination, FooterInfo, MenuEdit },
	props: {
		id: Number,
		fdbk: Number,
	},
	computed: {
		...mapGetters('auth', ['userID']),
		isReady() {
			return !!this.item.id;
		},
		item() {
			return this.$store.getters['feedbacks/current'] || {};
		},
		items() {
			return this.$store.getters['feedbacks/byAction'](this.id);
		},
		isAuthor() {
			return this.userID === this.item.author;
		},
		index() {
			return this.items.indexOf(this.item);
		},
		total() {
			return this.items.length;
		},
		isFirstItem() {
			return this.index === 0;
		},
		isLastItem() {
			return this.index === this.total - 1;
		},
	},
	filters: {
		toRelativeDate,
		toAbsoluteDate,
	},
	methods: {
		toSimpleDate,
		compile,
		async fetchData() {
			await this.$store.dispatch('feedbacks/fetchByActionID', this.id);
			this.$store.commit('feedbacks/setCurrent', this.fdbk);
		},
		navBack() {
			this.$router.go(-1);
		},
		prevItem({ index }) {
			const previous = this.items[index];
			this.$router.replace({ name: 'action-feedback', params: { id: this.id, fdbk: previous.id } });
		},
		nextItem({ index }) {
			const next = this.items[index];
			this.$router.replace({ name: 'action-feedback', params: { id: this.id, fdbk: next.id } });
		},
		edit() {
			this.$store.dispatch('feedbacks/editFeedback', { item: this.item });
		},
		remove() {
			this.$store.dispatch('feedbacks/deleteFeedback', { item: this.item });
		},
	},
	created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData',
	},
};
</script>
